export default {
    url: '/edit/:id',
    template: `
        <user-tasklist-edit tasklist="vm.tasklist"/>`,
    resolve: {
        tasklist (TasklistResource, $stateParams) {
            return TasklistResource.get({ id: $stateParams.id, expand: 'tasklistTasks.file,tasklistTemplate,user,tasklistTasks.completor' }).$promise;
        }
    },
    controller (tasklist) {
        this.tasklist = tasklist;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/tasklist/edit/index.js